import React, { Component } from "react";
import {
  View,
  KeyboardAvoidingView,
  Dimensions,
  StyleSheet,
} from "react-native";
import Text from "./TextFont";
import { translate } from "../locales/translate";
import QRCode from "react-native-qrcode-svg";
import * as CONSTS from "../../assets/consts";

const width = Math.min(Dimensions.get("screen"), CONSTS.WEB_MAX_WIDTH);

class QRCodeItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <KeyboardAvoidingView>
        <View style={[style.parentStyle, this.props.containerStyle]}>
          <View style={style.viewStyle}>
            {this.props.name != null && (
              <Text style={style.textStyle}>
                {translate("app.buildingName")}
                {" : "}
                {this.props.name}
              </Text>
            )}
          </View>
          <QRCode
            value={this.props.value}
            size={this.props.size || (width * 2) / 3}
          />
        </View>
      </KeyboardAvoidingView>
    );
  }
}
const style = StyleSheet.create({
  parentStyle: {
    alignItems: "center",
    justifyContent: "center",
  },
  viewStyle: {
    alignItems: "flex-start",
  },
  textStyle: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
    fontSize: 14,
    marginBottom: 10,
  },
});
export default QRCodeItem;
